// extracted by mini-css-extract-plugin
export var cardHeader = "_fo-0";
export var reorderHandle = "_fo-3";
export var titleArea = "_fo-1";
export var titleAreaWithHandle = "_fo-2";